module.exports = __webpack_public_path__ + "static/c15-665d830c21d81ce4446bc803279c1194.jpg";